export default {
  submit: 'Submit',
  reset_form: 'Reset form',
  signin: 'Sign In',
  login: 'Log In',
  username: 'Username',
  password: 'Password',
  remember_me: 'Remember me',
  language: 'Language',
  english: 'English',
  italiano: 'Italiano',
  inizia: 'Start',
  NO: 'NO',
  SI: 'YES',
  Indietro: 'Back',
  indietro: 'back',
  Continua: 'Continue',
  Home: 'Home',
  'Benvenuti nel software guida per la scelta di pali e torri per illuminazione.': 'Welcome to the restricted area of Pali Campion Srl. ',
  'Il software consente di accedere al catalogo prodotti della ditta Campion, attraverso una comoda interfaccia di ricerca.':
    'Upon free registration, you will access our webapp to guide you in the choice of the right lighting poles and towers, and also to all the technical specifications of our products. If you register, you agree to be contacted by one of our commercial agents.',
  'Sezioni principali': 'Sections',
  "Accedi all'applicazione": 'Access the web application',
  "Esci dall'applicazione": 'Terminate session',
  'guida introduttiva': 'getting started',
  'Ricerca pali': 'Search lighting columns/masts',
  'ricerca e consultazione': 'research and consultation',
  'Ricerca palo': 'Search',
  'Premere il pulsante "nuova ricerca" per iniziare.': 'Press the "new search" button to start.',
  'nuova ricerca': 'new search',
  'Recupero ricerche precedenti...': 'Retrieving previous searches...',
  'Ricerche precedenti': 'Previous searches',
  'Non hai ancora salvato nessuna ricerca.': "You haven't saved any searches yet.",
  'Cancellare la ricerca salvata': 'Delete this saved search',
  'tipologia di palo': 'type of pole',
  'Selezionare o modificare la tipologia di palo richiesta': 'Select or modify the type of pole required',
  'configurazione palo': 'pole configuration',
  'Selezionare o modificare la configurazione di palo richiesto': 'Select or modify the required pole configuration',
  caratteristiche: 'features',
  Caratteristiche: 'characteristics of selected ',
  'Seleziona le caratteristiche del palo.': 'Select the characteristics of the pole.',
  località: 'locality',
  "Seleziona la località di installazione sulla mappa oppure inserisci l'indirizzo o le coordinate":
    'Select the installation location on the map or enter the address or coordinates',
  "Non è stato possibile recuperare le coordinate per l'indirizzo richiesto.":
    'We could not retrieve coordinates for the requested address.',
  risultati: 'results',
  'Calcolo risultati.': 'Calculating results.',
  'Tipologia di Palo': 'Type of Pole',
  'Caricamento catalogo': ' Loading Catalog',
  ERRORE: 'ERROR',
  'NON TROVATO': 'NOT FOUND',
  'Nessuna tipologia di palo disponibile': 'No pole types available',
  'Errore durante il recupero delle tipologie di palo: ': 'Error while recovering the types of pole:',
  'Configurazione per': 'Configuration for',
  'Altezza punto luce': 'Height up to the light source',
  'Sporgenza punto luce': 'Bracket outreach',
  'Superficie esposta di ogni apparecchio': 'Exposed surface of each luminarie',
  'Superficie esposta testapalo': 'Total exposed surface at the top',
  'Superficie esposta sbraccio': 'Exposed surface for each single bracket',
  'Verifica idoneità strutturale con corpo illuminante stradale (0,05mq – 10kg) montato in cima':
    'Check structural suitability with a lighting body (0.05mq - 10kg) mounted on top',
  'Dovranno essere assunti i dati (superficie esposta, coefficienti di forma, peso) forniti dalle Ditte Costruttrici dei proiettori stessi.':
    'Data given by the manufacturers of the fixture itself (exposed surface, shape coefficient, weight) may be assumed.',
  'In mancanza di dati specifici si applicheranno i seguenti:': 'If specific data are not available, the following data will be applied:',
  'Armature stradali 0,2 m² cadauna': 'Straight luminare 0.2 sqm each',
  'Proiettori per illuminazione:': 'Foodlights:',
  Potenza: 'Power',
  larghezza: 'Width',
  altezza: 'Height',
  Profondità: 'Depth',
  'altezza tot.': 'Total ht.',
  'Area exp.': 'Exposed surface',
  'Geometria proiettori generici simmetrici': 'Dimension of symetric generic floodlights',
  'Geometria proiettori generici asimmetrici': 'Dimension of asymetric generic floodlights',
  'In casi generici:': 'If specific data are not available, the following data will be applied:',
  'Disposizione proiettori': 'Floodlight location',
  'Potenza proiettori': "Single floodlight's width",
  'nessuna copertura': 'without dome or cap',
  'con cupola o cappello': 'with dome or cap',
  'Numero proiettori': 'Floodlights number',
  'Cupola/cappello': 'Dome/ or /Cap',
  Asimmetrici: 'Asymmetric',
  Simmetrici: 'Symmetric',
  'Verranno assunti i dati (superficie esposta, coefficienti di forma, peso) sulla base dei seguenti parametri:':
    'Data (exposed surface, shape coefficient, weight) will be assumed according to the following parameters:',
  'Superficie totale esposta al vento': 'Total exposed surface',
  "sposta la mappa sul punto di installazione o scrivi l'indirizzo nel campo seguente":
    'move the map to the installation point or write the address in the following field',
  'Località di installazione': 'Installation location',
  indirizzo: 'location',
  esposizione: 'wind exposition',
  terreno: 'terrain',
  collocazione: 'placement',
  'I valori sono impostati automaticamente spostando il punto sulla mappa e possono essere modificati prima di procedere.':
    'The values are set automatically by moving the point on the map and can be changed before proceeding.',
  quota: 'altitude',
  'distanza dal mare': 'distance from the sea',
  'velocità del vento reale a 10m dal piano campagna': 'real wind speed at 10m from the ground level',
  Indirizzo: 'Address',
  'Mare, oltre 2Km di distanza dalla costa': 'Sea, over 2km away from the coast',
  'Mare, entro 2Km di distanza  dalla costa': 'Sea, within 2km from the coast',
  'Mare, entro 500m di distanza  dalla costa': 'Sea, within 500m from the coast',
  'Entroterra, entro 10Km di distanza dalla costa': 'Inland, within 10km from the coast',
  'Entroterra, entro 40Km di distanza dalla costa': 'Inland, within 40km from the coast',
  'Entroterra, oltre 40Km di distanza dalla costa': 'Inland, over 40km away from the coast',
  "Valle d'Aosta, Piemonte, Lombardia, Trentino-Alto Adige, Veneto, Friuli Venezia-Giulia (esclusa provincia di Trieste)":
    "Valle d'Aosta, Piedmont, Lombardy, Trentino-Alto Adige, Veneto, Friuli Venezia-Giulia (excluding the province of Trieste)",
  'Toscana, Marche, Umbria, Lazio, Abruzzo, Molise, Campania, Puglia, Basilicata, Calabria (esclusa provincia di Reggio Calabria)':
    'Tuscany, Marche, Umbria, Lazio, Abruzzo, Molise, Campania, Puglia, Basilicata, Calabria (excluding the province of Reggio Calabria)',
  'Sicilia e provincia di Reggio Calabria': 'Sicily and the province of Reggio Calabria',
  "Sardegna (zona a oriente della retta congiungente Capo Teulada con l'Isola della Maddalena)":
    'Sardinia (area to the east of the straight line joining Capo Teulada with the Island of Maddalena)',
  "Sardegna (zona a occidente della retta congiungente Capo Teulada con l'Isola della Maddalena)":
    'Sardinia (area to the west of the straight line joining Capo Teulada with the island of Maddalena)',
  'Provincia di Trieste': 'Province of Trieste',
  "Isole (con l'eccezione di Sicilia e Sardegna) e mare aperto": 'Islands (with the exception of Sicily and Sardinia) and open sea',
  Zona: 'Zone',
  'inferiore a 500m s.l.m.': 'less than 500m a.s.l.',
  'tra i 500m e i 750m s.l.m.': 'between 500m and 750m a.s.l.',
  'tra i 750m e i 1000m s.l.m.': 'between 750m and 1000m a.s.l.',
  'tra i 1000m e i 1500m s.l.m.': 'between 1000m and 1500m a.s.l.',
  'oltre i 1500m s.l.m.': 'over 1500m a.s.l.',
  'zona di ventosità': 'wind zone',
  "L'assegnazione della classe di rugosità non dipende dalla conformazione orografica e topografica del terreno. Affinchè una costruzione possa dirsi ubicata nelle prime due classi è necessario che la situazione che contraddistingue la classe permanga intorno alla costruzione per non meno di 1 km e comunque non meno di 20 volte l'altezza dell'edificio. Laddove sussistano dubbi sulla scelta della classe, a meno di analisi rigorose, verrà assegnata la classe più sfavorevole.":
    'The assignment of the roughness class does not depend on the orographic and topographical conformation of the terrain. In order for a building to be located in the first two classes, the situation that distinguishes the class must remain around the building for no less than 1 km and in any case no less than 20 times the height of the building. Where there are doubts about the choice of class, unless rigorous analysis is carried out, the most unfavorable class will be assigned.',
  'Aree urbane in cui almeno il 15% della superficie è coperto da edifici con altezza media maggiore di 15 metri.':
    'Urban Areas with at least 15% of surface covered by buildings with average height greater then 15 meters.',
  'Aree suburbane o industriali e foreste permanenti.': 'Suburban or industrial, and permanent forest.',
  'Terreni coltivati cintati da siepi, qualche piccola costruzione agricola, case o alberi.':
    'Cropped land enclosed by hedges, some little agricultural builds, houses or trees.',
  'Costa marina. Costa di lago con lunghezza sopravvento di almeno 5 Km. Terreno piano, senza ostacoli.':
    'Marine Coast. Lake Coast with windward length at least of 5 Km. Plain ground, without obstacles',
  'Scegli la categoria di rugosità del terreno': 'Choose the soil roughness category',
  Ricerca: 'Search',
  'Ricerca in corso': 'Searching',
  'Sono state individuate': '',
  'torri corrispondenti ai parametri di ricerca:': 'high masts match the search parameters:',
  'Sono stati individuati': '',
  'pali corrispondenti ai parametri di ricerca:': 'columns match the search parameters:',
  'È stata individuata': '',
  'torre corrispondente ai parametri di ricerca:': 'high mast matches the search parameters:',
  'È stato individuato': '',
  'palo corrispondente ai parametri di ricerca:': 'column matches the search parameters:',
  Palo: 'Column',
  'con sbraccio': 'with bracket',
  'con piattaforma': 'with platform',
  'con paranco manuale': 'with manual hoist',
  'con paranco elettrico': 'with electric hoist',
  'Errore:': 'Error:',
  'Nessun palo corrisponde alle caratteristiche indicate.': 'No standard column corresponds to the indicated characteristics.',
  'Puoi inviare la richiesta al nostro ufficio tecnico, per una progettazione dedicata':
    'You can send the request to our technical office, for a dedicated design',
  'Parametri inseriti:': 'Requested parameters:',
  "Errore nell'invio della richiesta": 'Error sending the request',
  'Tipologia di palo': 'Type',
  Configurazione: 'Configuration',
  'Zona di ventosità': 'Wind zone',
  'Posizione geografica': 'Geographical location',
  'Categoria di esposizione': 'Exposure category',
  'Calcolo in corso...': 'Calculating...',
  'Velocità del vento da progetto': 'Design wind speed',
  'Classe di esposizione EN 40-3-1': 'EN 40-3-1 exposure class',
  'Velocità V': 'Wind speed V',
  Sporgenza: 'Bracket outreach',
  Proiettori: 'Projectors',
  Orientazione: 'Floodlight location',
  'Superficie esposta': 'Exposed surface',
  'Salva ricerca': 'Save search',
  'Nuova ricerca': 'New search',
  'Errore nel salvataggio': 'Error saving the search data',
  'Impossibile salvare la ricerca.': 'Failed to save search.',
  'Causa:': 'Reason:',
  'Salva ricerca con nome': 'Save search as',
  'Inserire un nome': 'Enter a name',
  Annulla: 'Cancel',
  Salva: 'Save',
  Invia: 'Send',
  'Errore durante il recupero dei risultati: ': 'Error retrieving results: ',
  Torre: 'High mast',
  'proiettori aventi larghezza': 'projectors, width ',
  'proiettore avente larghezza': 'projector, width ',
  'Superficie proiettori': "Projector's surface exposed to the wind",
  ', con cupola o cappello': ', with dome or cap',
  peso: 'weight',
  Esempi_configurazione: 'Configuration examples for ',
  Testapalo: 'Straight',
  'Sbraccio singolo': 'Single bracket',
  'Sbraccio doppio': 'Double bracket',
  '3 o 4 bracci': '3-4 brackets',
  'Torre ascensionale': 'High mast with mobile crown/panel',
  'Torre con scala e piattaforma': 'High masts with ladder',
  dati_assunti:
    'Data given by the manufacturers of the fixture itself (exposed surface, shape coefficient, weight) may be assumed. If specific data are not available, the following data will be applied:',
  'Peso di un proiettore': 'Weight of a single projector',
  'Classe di rugosità del terreno': 'Rugosity class',
  'Usare massimo 50 caratteri': 'Please use max 150 characters',
  'Usare massimo 500 caratteri': 'Please use max 500 characters',
  'Pali a sicurezza passiva': 'Passive Safety Columns',
  'Pali per illuminazione': 'Lighting columns',
  'Torri portafari': 'Towers',
  "Errore nell'invio della richiesta.": 'Error sending your request.',
  Esempi: 'Examples',
  'Email non valida': 'Invalid email',
  Fax: 'Telefax',
  Telefono: 'Phone',
  Cellulare: 'Phone number',
  Stato: 'Country',
  Provincia: 'Province/Region/County',
  Localita: 'City/Locality',
  CAP: 'ZIP code',
  'Ragione sociale': 'Company name',
  username_signin: 'Username (to be used at log-in)',
  Email: 'e-mail',
  Nome: 'First name',
  Cognome: 'Last name',
  Password: 'Password',
  'E-mail': 'E-mail',
  'Sito internet': 'Website',
  'Password (ripetere)': 'Password (repeat)',
  'email richiesta': 'Email is missing',
  richiesto: 'This field is required',
  'non corrispondono': 'Passwords are not equal',
  privacy: 'I accept the privacy policy',
  'maggiori informazioni': 'more info',
  'privacy richiesta': 'Please accept our privacy policy',
  'Tipo utente': 'User type',
  Rivenditore: 'Reseller',
  Installatore: 'Installer',
  'Impresa Costruzioni': 'Construction company',
  'Azienda utilizzatrice': 'User company',
  Ente: 'Entity, public body',
  'Studio Progettazione': 'Design studio',
  'Agente di commercio': 'Trade agent',
  Privato: 'Private',
  'Area download': 'Download area',
  'Clicca sul nome del prodotto per scaricare le schede tecniche (File: doc, dwg, pdf).':
    'Click on the product name to download the technical data sheets(File: doc, dwg, pdf).',
  'PORTATE PALI STANDARD': 'CARRIAGE LOAD TABLE FOR STANDARD COLUMNS',
  'FONDAZIONI PALI STANDARD': 'STANDARD POLES FOUNDATIONS',

  'Database contenente i limiti di portata':
    'Database containing the carriage load limits of all our standard columns, in the different wind zone foreseen from the standard. ',
  'Per leggere il file è necessario Microsoft Excel, di comune utilizzo nella stragrande maggioranza dei pc':
    'In order to read it You need Excel, commonly used on the majority of pc',
  'Database contenente le dimensioni minime delle fondazione necessarie per i pali standard.':
    'database containing the minimum foundation dimensions required for standard poles.',
  'TORRI A CORONA MOBILE': 'HIGH MASTS WITH MOBILE CROWN',
  'TORRI A PANNELLO MOBILE': 'HIGHT MASTS WITH MOBILE PANEL',
  'TORRI CON SCALA E PIATTAFORMA': 'HIGH MASTS WITH LADDER AND PLATFORM',
  MONTAGGI: 'ASSEMBLAGES',
  'PALI CONICI': 'CONICAL COLUMNS',
  'PALI RASTREMATI': 'STEPPED COLUMNS',
  'PALI OTTAGONALI E POLIGONALI': 'OCTAGNAL AND POLYGONAL COLUMNS',
  'PALI COMPONIBILI CAMPIONLIGHT': 'COMPOSABLE DECORATIVE COLUMNS',
  'LAVORAZIONI A RICHIESTA': 'WORKINGS ON REQUEST',
  'SBRACCI E TRAVERSE ACCESSORI PER PALI DRITTI': 'BRACKETS AND CROSSBARS FOR STRAIGHT COLUMNS',
  'PALI BASCULANTI RIBALTABILI': 'COLLAPSIBLE COLUMNS',
  'PALI PER LINEE AEREE UNIFICAZIONE ENEL': 'COLUMNS FOR OVERHEAD LINES',
  'PALI SEMAFORICI': 'TRAFFIC LIGHTS COLUMNS',
  'PALI DECORATIVI ARREDO URBANO': 'DECORATIVE POLES FOR URBAN FURNITURE',
  'SISTEMA SAVE A SICUREZZA PASSIVA': 'PASSIVE SAFETY COLUMNS',
  'PALI CONICI DRITTI': 'STRAIGHT CONICAL COLUMNS',
  'PALI CONICI CURVATI': 'CURVED CONICAL COLUMNS',
  'Sbracci cilindrici ricurvi': 'Cylindrical curved brackets',
  'Sbracci a squadro': 'Straight cylindrical brackets',
  'Attacchi a pipa': 'Small brakets',
  'Traverse portaproiettori': 'Crossbars for floodlights',
  'Kit fotovoltaico': 'Photovoltaic Kit',
  'SCHEDE TECNICHE': 'TECHNICAL DATA SHEETS',
  'cerca tra i documenti': 'search the documents',
  'schede tecniche prodotti, fondazioni, portate': 'Technical data sheets, carriage load limits, foundations',
  'Tiro massimo di progetto': 'Ultimate design horizontal load (daN)',
  descrizione_tiro_max_progetto:
    'the traction load or theoretic collapse load is the value that generates a diagram of bending moment which approximates in favour to the safety (coefficient 2 - CEI 11- 4), the diagram of the bending moments generated for the comprehensive action due to the conductors and to the wind pressure distributed along the shaft.',
  Lunghezza: 'Length',
  'Visualizza su google maps': 'Show on google maps',
  'Coordinate di installazione': 'Location',
  tiro: 'Tip load',
  Altezza: 'Height',
  direzione: 'Direction',
  Direzione: 'Direction',
  'Quota di applicazione': 'Application quote',
  sbraccio: 'Bracket',
  Sbraccio: 'Bracket',
  'carico orizzontale': 'horizontal load',
  'carico verticale': 'vertical load',
  'Nessun carico presente.': 'No load provided.',
  'Aggiungi carico': 'Add load',
  'Campo obbligatorio': 'Required',
  'Nessun dato inserito. Aggiungi una riga': 'No data available. Please add a row',
  'Albero dei carichi': 'Load tree',
  'Schema disposizione mensole': 'Brackets disposition',
  'Inserire un valore numerico': 'Please insert a number',
  'Inserire un valore maggiore di 0': 'Please insert a number greater than 0',
  'Riepilogo e invio email per dimensionamento ': 'Summary and email request for custom sizing:',
  'Eventuali annotazioni': 'Additional requests',
  'Premere il pulsante': 'Press',
  INVIA: 'SEND',
  'per trasmettere una richiesta al nostro ufficio tecnico, per una progettazione dedicata.':
    'to send a request to our technical office, for a dedicated design.',
  'Salva bozza ricerca': 'Save draft search',
  'Messaggio (opzionale). I dati della ricerca saranno inseriti automaticamente': 'Message (optional). The search data will be entered automatically ',
  'Messaggio inviato con successo.': 'Message sent successfully.',
  'Messaggio (opzionale)': 'Message (optional)',
  'Interdistanza tra i pali (campata)': 'Spacing between the columns in line (span)',
  'Diametro del cavo': 'Cable diameter',
  'Peso del cavo': 'Cable weight',
  'Fune di sostegno': 'Supporting rope',
  'Diametro fune': 'Rope diameter',
  'Peso fune': 'Rope weight',
  'Posizione sostegno': 'Position of the column',
  rettifilo: 'straight',
  angolo: 'angle',
  capolinea: 'end column',
  Presente: 'present',
  'La richiesta sarà salvata automaticamente.': 'The request will be saved automatically.',
  'Bozza salvata': 'Draft saved',
  'Torna al riepilogo': 'Back to summary',
  'Ancoraggio base': 'Base anchoring',
  'infissione diretta': 'direct planting',
  'piastra base e tirafondi': 'welded plate and anchor bolts',
  Scala: 'Ladder',
  'Descrizione Pale e rotore/Navicella': 'Description of the turbine and rotor',
  'È necessario indicare le dimensioni, il peso e la frequenza naturale di vibrazione.': 'Size, weight and natural vibration frequency should be indicated.',
  Allegati: 'Attachments',
  'Carica allegato': 'Upload attachment',
  'File presenti': 'Uploaded files',
  'Rastrelliera esterna porta cavi': 'External cable tray',
  Piattaforma: 'Platform',
  'Limite oscillazione in cima': 'Oscillation limits on top',
  'Velocità del vento per verifica dello spostamento in cima': 'Wind speed to verify the displacement at the top',
  'Spostamento massimo': 'Maximum displacement',
  'Descrizione antenne': 'Antennas description',
  'È necessario indicare le dimensioni, il peso e la disposizione degli apparati da installare.':
    'It is necessary to indicate the dimensions, weight and arrangement of the equipment to be installed.',
  Modello: 'Model',
  'a bandiera': 'cantilever',
  'a farfalla': 'butterfly',
  'a cavalletto': 'tripod',
  pedonale: 'with bracket',
  'Descrizione segnaletica': 'Sign boards description',
  'È necessario indicare le dimensioni, il peso e la posizione della segnaletica.': 'The size, weight and location of the signs must be indicated.',
  'Sporgenza bracci': 'Brackets outreach',
  'Superficie esposta al vento (lanterne e pannello contrasto)': 'Surface exposed to the wind (lights and boards)',
  'Sup.Tot.': 'Total Surface',
  'Sostegno portainsegna': 'Sign support',
  'normalmente con altezze da 15 a 25 metri': 'normally 15 to 25 meters hight',
  'normalmente con altezze da 20 a 30 metri': 'normally 20 to 30 meters hight',
  'Torre portainsegna con piattaforma': 'Sign support mast with platform',
  'Torre portainsegna luminosa': 'High mast for lighting sign support',
  'a movimentazione motorizzata fino a 1000Kg': 'with motorised movement up to 1000kg',
  'normalmente con altezze da 20 a 35 metri': 'normally 20 up to 35 meters hight',
  'Descrizione insegna': 'Sign description',
  "È necessario indicare le dimensioni, il peso e la disposizione dell'insegna.": 'The dimensions, weight and arrangement of the sign must be indicated.',
  'Palo alzabandiera': 'Flag columns',
  'Palo con braccio rotante per stendardo': 'Column with pivoting bracket for banner support',
  'Torre alzabandiera': 'Flag high mast',
  'Altezza bandiera': 'Flag height',
  'Larghezza bandiera': 'Flag width',
  'Distanza tra i pali': 'Distance between poles',
  'Descrizione della rete': 'Fence description',
  'È necessario indicare le dimensioni della maglia e del filo.': 'It is necessary to indicate the size of the mesh and the thread diameter.',
  'Descrizione degli apparati': 'Description of the mounted devices',
  'È necessario indicare le dimensioni, i pesi, la disposizione degli apparati, delle telecamere, delle antenne wifi e delle cassette di derivazione.':
    'It is necessary to indicate the dimensions, the weights, the arrangement of the equipment, cameras, wifi antennas and junction boxes.',
  'Sporgenza di un braccio': 'Single bracket outreach',
  Campata: 'Span',
  Visualizza: 'Show',
  'Torna al sito': 'Visit the website',
  'Torna al sito palicampion.it': 'Back to public area in palicampion.it',
  "Esci dall'area riservata": 'Logout',
  'Pali ENEL DS3010': 'Overhead line support',
  'Pali ENEL DS3012': 'MT Overhead line',
  'Sostegni per elettrodotti': 'Supports for High Voltage Power Lines',
  'Pali con linea in cavo aereo': 'Column with overhead cable line',
  'Pali per linee MT-BT unificati ENEL': 'Steel poles for distibution networks',
  'Pali per videosorveglianza': 'Pali per videosorveglianza',
  'Pali per recinzioni':'Pali per recinzioni',
  'Pali portabandiera':'Pali portabandiera',
  'Pali portainsegna': 'Pali portainsegna',
  'Pali semaforici': 'Pali semaforici',
  'Pali per segnaletica': 'Pali per segnaletica',
  'Pali per telecomunicazioni': 'Pali per telecomunicazioni',
  'Pali Eolici': 'Pali eolici',
  'Pali linee aeree': 'Pali linee aeree'

}
